import React, { useMemo } from "react"
import ShortReservationPopup from "../../components/ShortReservationPopup"
import { PopupTypes } from "./icons"
import PropTypes from 'prop-types'
import { useCurrentHotel } from "../../hooks/useCurrentHotel"

export const HomePagePopups = ({active, HotelId, ...rest})=>{
    const currentHotel = useCurrentHotel();
    const effectiveHotelId = HotelId || currentHotel?.Id;
    const newReservation = useMemo(()=>({
        HotelId: effectiveHotelId,
        ReservationPricingTypeId: 1,
        TotalAmountProductCurrentBeforeTax: 0,
        TotalAmountProductCurrentAfterTax: 0
    }), [effectiveHotelId])

    return <>
        <ShortReservationPopup open={active === PopupTypes.ShortReservation} reservation={newReservation} { ...rest}/>
    </>
}


HomePagePopups.propTypes = {
    active: PropTypes.number,
    HotelId: PropTypes.number
}